import { render, staticRenderFns } from "./BursaryDashboard.vue?vue&type=template&id=1b0bc28a&scoped=true"
import script from "./BursaryDashboard.vue?vue&type=script&lang=js"
export * from "./BursaryDashboard.vue?vue&type=script&lang=js"
import style0 from "./BursaryDashboard.vue?vue&type=style&index=0&id=1b0bc28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bc28a",
  null
  
)

export default component.exports